<div class="inner-main-profile">
    <div class="error-section face-container-inner-bg p-2 mb-3">
        <div class="err-image">
            <img class="error-light" src="assets/images/err-black.png" alt="">
            <img class="error-dark" src="assets/images/err-white.png" alt="">
        </div>
    </div>
</div>